import { AddNewUserService } from '../services/add-new-user-service';
import { AddOrgRoleService } from '../services/add-org-role-service';
import { AddProductPermissionService } from '../services/add-product-permission-service';
import { NewUserService } from '../services/new-user-service';
import { UserFormType } from './user-form-type';

export class NewUserServiceFactory {
	static create(
		type: UserFormType,
		params: {
			orgId?: number;
			orgType?: string;
			productId?: number;
		},
	): NewUserService {
		switch (type) {
			case 'newUser':
				return new AddNewUserService();
			case 'orgRole': {
				if (params.orgId && params.orgType) {
					return new AddOrgRoleService(params.orgId, params.orgType);
				}
				throw new Error('Required org id and org type arguments not supplied');
			}
			case 'productPermission': {
				if (params.productId) {
					return new AddProductPermissionService(params.productId);
				}
				throw new Error('Required product id argument not supplied');
			}
			default: {
				throw new Error('Unknown user form type');
			}
		}
	}
}
